import React from 'react';

import { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';
import type { AIEventsInstrumentationConfig } from '@atlassian/ai-analytics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { fg } from '@confluence/feature-gating';

import { PageCatchupStreamingComponent } from './PageCatchupStreamingComponent';
import { PageCatchupWrapperComponent } from './PageCatchupWrapperComponent';

export type PageCatchupWrapperComponentProps = {
	contentId: string;
	contentType: string;
	spaceKey: string;
	source?: string;
	selectedVersions?: Set<any>;
	isInObjectSidebar?: boolean;
	setIsOpen: (open: boolean) => void;
	contentPath: string;
	showFooter?: boolean;
};

export const PageCatchupComponentWithErrorBoundary = (props: PageCatchupWrapperComponentProps) => {
	const aiAnalyticsConfig: AIEventsInstrumentationConfig = {
		product: 'confluence',
		subproduct: 'confluence',
		source: props.source ?? 'confluencePage',
		aiFeatureName: 'pageCatchup',
		proactiveGeneratedAI: 0,
		userGeneratedAI: 1,
	};

	const pageCatchupComponent = fg('confluence_ai_page_catchup_convo_ai_migration') ? (
		<PageCatchupWrapperComponent {...props} />
	) : (
		<PageCatchupStreamingComponent {...props} />
	);

	return (
		<ErrorBoundary attribution={Attribution.SMARTS}>
			<AIEventsInstrumentationProvider config={aiAnalyticsConfig}>
				{pageCatchupComponent}
			</AIEventsInstrumentationProvider>
		</ErrorBoundary>
	);
};
